export default "__VITE_PUBLIC_ASSET__600d3520__"